import * as Yup from 'yup';
import { MAX_FILES_COUNT, MAX_SIZE_IN_MB } from './constants';

const fileSizeValidation = (value, maxSizeInMb) => {
  const oversizedFiles = value?.filter(
    (file) => file.size > maxSizeInMb * 1024 * 1024,
  );
  return oversizedFiles?.length <= 0;
};

const fileCountValidation = (value, maxCount) => {
  return value?.length <= maxCount;
};

const fileTypeValidation = (value) => {
  const allowedExtensions = [
    '.jpg',
    '.jpeg',
    '.pdf',
    '.png',
    '.xls',
    '.xlsx',
    '.xlsm',
  ];
  const invalidFiles = value?.filter((file) => {
    const fileName = file.name.toLowerCase();
    return !allowedExtensions.some((ext) => fileName.endsWith(ext));
  });
  return invalidFiles?.length === 0;
};

export const reportFailureValidationSchema = ({ t }) => {
  return Yup.object().shape({
    faliureType: Yup.string().required(
      t('failure_notification.failure_type_required'),
    ),
    solutionProviderName: Yup.string()
      .max(100, t('failure_notification.solutionProviderName_max_length'))
      .required(t('failure_notification.solution_provider_name_required')),
    technicalFailureDescription: Yup.string()
      .max(1000, t('failure_notification.failure_description_max_lenth'))
      .required(t('failure_notification.failure_description_required')),
    technicalFailureDate: Yup.string()
      .nullable()
      .required(t('failure_notification.date_of_failure_required')),
    technicalFailureTime: Yup.string().required(
      t('failure_notification.time_of_failure_required'),
    ),
    expectedResolutionDate: Yup.string()
      .nullable()
      .required(t('failure_notification.expected_resolution_date_required')),
    supportingDocuments: Yup.mixed()
      .test(
        'fileSize',
        t('failure_notification.supporting_document_file_size_validation', {
          size: MAX_SIZE_IN_MB,
        }),
        (value) => fileSizeValidation(value, MAX_SIZE_IN_MB),
      )
      .test(
        'fileCount',
        t('failure_notification.supporting_document_files_count_validation', {
          count: MAX_FILES_COUNT,
        }),
        (value) => fileCountValidation(value, MAX_FILES_COUNT),
      )
      .test(
        'fileType',
        t('failure_notification.supporting_document_file_type_validation'),
        (value) => fileTypeValidation(value),
      ),
  });
};

export const resolveFailureValidationSchema = ({ t }) => {
  return Yup.object().shape({
    resolutionDate: Yup.string()
      .nullable()
      .required(t('failure_notification.resolution_date_required'))
      .test(
        'notFutureDate',
        t('failure_notification.resolution_date_future_date_validation'),
        (value) => !value || new Date(value) <= new Date(),
      ),
    resolutionTime: Yup.string().required(
      t('failure_notification.resolution_time_required'),
    ),
    additionalDetails: Yup.string().max(
      1000,
      t('failure_notification.additional_details_max_lenth'),
    ),
    supportingDocuments: Yup.mixed()
      .test(
        'fileSize',
        t('failure_notification.supporting_document_file_size_validation', {
          size: MAX_SIZE_IN_MB,
        }),
        (value) => fileSizeValidation(value, MAX_SIZE_IN_MB),
      )
      .test(
        'fileCount',
        t('failure_notification.supporting_document_files_count_validation', {
          count: MAX_FILES_COUNT,
        }),
        (value) => fileCountValidation(value, MAX_FILES_COUNT),
      )
      .test(
        'fileType',
        t('failure_notification.supporting_document_file_type_validation'),
        (value) => fileTypeValidation(value),
      ),
  });
};
